import {
  collection,
  documentId,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const GetTotalPropertiesForAgent = async (propertyId) => {
  /**
   * input: null
   * output: agent properties document / collection
   * description: get agent properties / get documents
   */
  try {
    const propertyCollection = await collection(db, "properties");

    const q = query(propertyCollection, where(documentId(), "in", propertyId));
    const agentPropertySnapshot = await getDocs(q);

    let agentProperties = [];

    agentPropertySnapshot.forEach((doc) => {
      agentProperties.push({ ...doc.data(), id: doc.id });
    });
    return agentProperties;
  } catch (error) {
    console.log(error);
  }
};

export default GetTotalPropertiesForAgent;
